<div @stagger class="py-4" *ngIf="mailService.folderCounts | async as folderCounts">
  <p @fadeInUp class="text-secondary text-xs font-medium px-6 mb-2">Browse</p>
  <vex-mail-sidenav-link
    (click)="selectFolder(link.route[0])"
    *ngFor="let link of links"
    @fadeInUp
    [active]="(mailService.selectedFolder | async) === link.route[0]"
    [total]="folderCounts[link.route[0]]?.total || 0"
    [unread]="folderCounts[link.route[0]]?.unread || 0"
    [link]="link"></vex-mail-sidenav-link>

  <p @fadeInUp class="text-secondary text-xs font-medium px-6 mt-8 mb-2">
    Labels
  </p>
  <vex-mail-sidenav-link
    (click)="selectFolder(link.route[0])"
    *ngFor="let link of labelLinks"
    @fadeInUp
    [active]="(mailService.selectedFolder | async) === link.route[0]"
    [total]="folderCounts[link.route[0]]?.total || 0"
    [unread]="folderCounts[link.route[0]]?.unread || 0"
    [link]="link"></vex-mail-sidenav-link>
</div>
